module.exports = __webpack_public_path__ + "img/menuIcon23.ee9f2b9d.png";